(function ($, app) {
    'use strict';

})(jQuery, window.app);